<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tit1"><a id="page_ii"></a><a id="page_iii"></a>Carthage at War</h1>
<p class="stit">Punic Armies c. 814–146 <span class="small">BC</span></p>
<p class="author">Joshua R. Hall</p>
<div class="img_container">
<img alt="Images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?09e90508